// Vorlagentexte für nicht umtauschbare Produkte (Sonderanfertigung, digitale
// Produkte, Lizenzen, personalisierte und versiegelte Ware).
// Auswahl pro Produkt via `product.exchange_notice`; zentrale Texte für
// `custom_made` und `digital` können unter Einstellungen → Produktseite
// überschrieben werden.

export const EXCHANGE_NOTICES = [
  {
    key: 'custom_made',
    label: 'Sonderanfertigung – vom Umtausch ausgeschlossen',
    badge: '★ Sonderanf.',
    tone: 'gold',
    title: 'Sonderanfertigung',
    short: 'Dieser Artikel wird speziell für Sie angefertigt und ist vom Umtausch ausgeschlossen.',
    text: 'Dieser Artikel wird speziell für Sie angefertigt und ist vom Umtausch ausgeschlossen. Bitte prüfe Größe, Farbe und Motiv sorgfältig vor dem Absenden der Bestellung.',
    legal: 'Nach § 312g Abs. 2 Nr. 1 BGB besteht bei Waren nach Kundenspezifikation kein gesetzliches Widerrufsrecht. Beim Kaufabschluss bestätigst du den Verzicht.',
  },
  {
    key: 'digital',
    label: 'Digitales Produkt / Download – kein Widerruf nach Bereitstellung',
    badge: '↓ Digital',
    tone: 'sky',
    title: 'Digitales Produkt / Download',
    short: 'Dieser Artikel wird digital bereitgestellt und ist nach Beginn des Downloads vom Umtausch ausgeschlossen.',
    text: 'Dieser Artikel wird digital bereitgestellt (Download oder Online-Zugang). Die Bereitstellung erfolgt sofort nach Zahlung – ein Umtausch oder eine Rückgabe ist danach nicht mehr möglich.',
    legal: 'Mit dem Kauf stimmst du der sofortigen Bereitstellung zu und bestätigst, dass dein Widerrufsrecht nach § 356 Abs. 5 BGB mit Beginn der Ausführung erlischt.',
  },
  {
    key: 'license',
    label: 'Lizenz / Zugangsschlüssel – kein Umtausch nach Freischaltung',
    badge: '# Lizenz',
    tone: 'sky',
    title: 'Lizenz / Zugangsschlüssel',
    short: 'Lizenzschlüssel und Zugänge sind nach der Freischaltung vom Umtausch ausgeschlossen.',
    text: 'Du erhältst einen persönlichen Lizenzschlüssel bzw. Zugang. Da der Schlüssel nach dem Versand nicht zurückgenommen oder erneut vergeben werden kann, ist ein Umtausch nach Freischaltung ausgeschlossen.',
    legal: 'Das Widerrufsrecht erlischt nach § 356 Abs. 5 BGB, sobald der Zugang bzw. Schlüssel bereitgestellt und die Ausführung begonnen wurde.',
  },
  {
    key: 'personalized',
    label: 'Personalisierte Ware (Name, Wunschtext, Motiv)',
    badge: '★ Personalisiert',
    tone: 'gold',
    title: 'Personalisierte Ware',
    short: 'Dieser Artikel wird mit Ihren persönlichen Angaben personalisiert und ist vom Umtausch ausgeschlossen.',
    text: 'Dieser Artikel wird mit deinen persönlichen Angaben (Name, Wunschtext oder eigenes Motiv) individuell veredelt. Da er dadurch nicht weiterverkauft werden kann, ist ein Umtausch ausgeschlossen. Bitte prüfe Schreibweise, Größe und Farbe genau.',
    legal: 'Nach § 312g Abs. 2 Nr. 1 BGB besteht bei Waren, die nach Kundenwunsch personalisiert wurden, kein gesetzliches Widerrufsrecht.',
  },
  {
    key: 'hygiene',
    label: 'Hygiene-/versiegelte Ware – kein Umtausch nach Öffnung',
    badge: '★ Versiegelt',
    tone: 'gold',
    title: 'Hygieneartikel / versiegelte Ware',
    short: 'Aus Hygienegründen ist dieser Artikel nach dem Öffnen der Versiegelung vom Umtausch ausgeschlossen.',
    text: 'Dieser Artikel ist aus Hygienegründen versiegelt. Solange die Versiegelung ungeöffnet ist, kannst du regulär widerrufen – nach dem Öffnen ist ein Umtausch oder eine Rückgabe nicht mehr möglich.',
    legal: 'Das Widerrufsrecht entfällt nach § 312g Abs. 2 Nr. 3 BGB bei versiegelten Waren, deren Versiegelung nach der Lieferung entfernt wurde.',
  },
];

export const DIGITAL_PRODUCT_TYPES = ['digital_download', 'elearning_course', 'license'];

export function getExchangeNoticeKey(product) {
  if (!product) return '';
  if (product.exchange_notice) return product.exchange_notice;
  if (product.is_custom_made) return 'custom_made';
  if (DIGITAL_PRODUCT_TYPES.includes(product.product_type)) return 'digital';
  return '';
}

// Liefert die aufgelöste Vorlage inkl. zentraler Text-Overrides aus den
// Shop-Einstellungen (nur für custom_made + digital vorhanden).
export function resolveExchangeNotice(product, settings) {
  const key = getExchangeNoticeKey(product);
  const tpl = EXCHANGE_NOTICES.find((n) => n.key === key);
  if (!tpl) return null;
  if (key === 'custom_made') {
    return {
      ...tpl,
      title: settings?.custom_made_notice_title || tpl.title,
      text: settings?.custom_made_notice_text || tpl.text,
      legal: settings?.custom_made_notice_legal || tpl.legal,
    };
  }
  if (key === 'digital') {
    if (settings?.digital_notice_enabled === false) return null;
    return {
      ...tpl,
      title: settings?.digital_notice_title || tpl.title,
      text: settings?.digital_notice_text || tpl.text,
      legal: settings?.digital_notice_legal || tpl.legal,
    };
  }
  return tpl;
}
